import { Button } from 'components/ui'
import type { FC } from 'react'
import { ChevronLeft, ChevronRight } from 'components/icons'
import cn from 'classnames'
import { useRouter } from 'next/router'
import s from './pagination.module.css'
import type { PaginationProps } from '.'

const Pagination: FC<PaginationProps> = ({ total, className, status = true }) => {
  const router = useRouter()

  const current = router?.query?.page || 1
  const actual = parseInt(current as unknown as string, 10)
  const currentPath = router.pathname
  const currentQuery = { ...router.query }

  function onNext() {
    currentQuery.page = (actual + 1).toString()
    router.push({
      pathname: currentPath,
      query: currentQuery,
    })
  }

  function onPrevious() {
    currentQuery.page = (actual - 1).toString()
    router.push({
      pathname: currentPath,
      query: currentQuery,
    })
  }

  return (
    <div className={cn(s.root, className)}>
      {current > 1 && (
        <Button onClick={onPrevious} variant="secondary" className={s.previous}>
          <ChevronLeft /> Anterior
        </Button>
      )}
      {status && (
        <div className={s.pages}>
          Página <strong>{current}</strong> de <strong>{total}</strong>
        </div>
      )}
      {current < total && (
        <Button onClick={onNext} variant="primary" className={s.next}>
          Próximo <ChevronRight />
        </Button>
      )}
    </div>
  )
}

export default Pagination
